<template>
  <bs-form :submit="$t('labels.submit')" @submit="$emit('submit')">
    <template v-slot:default="{ error }">
      <tuxedo-select :name="'customer_id'" :label="$tc('labels.customer', 1)" v-model="resource.customer_id" :options="customers" :insistReturn="'id'" :insistLabel="'name'" :error="error" />
      <tuxedo-select :name="'property_id'" :label="$tc('labels.property', 1)" v-model="resource.property_id" :options="properties" :insistReturn="'id'" :error="error" />
      <tuxedo-select :name="'users'" :label="$tc('labels.field_worker', 0)" v-model="resource.users" :options="users" :insistLabel="'name'" :multi="true" :error="error" />
      <toggle-field class="mb-2" :name="'multi_day'" :label="$t('labels.multi_day_booking')" v-model="resource.multi_day" :error="error"></toggle-field>
      <tuxedo-date v-if="!resource.multi_day" :type="'datetime'" :name="'due_at'" :insistFormat="'isoDateTime'" :label="$t('labels.due_at')" v-model="resource.due_at" :error="error" />
      <tuxedo-date v-if="!resource.multi_day" :type="'datetime'" :name="'end_at'" :insistFormat="'isoDateTime'" :label="$t('labels.end_time')" v-model="resource.end_at" :help="$t('tips.select_due_at', { resource: $t('labels.booking') })" :error="error" />
      <tuxedo-date v-if="resource.multi_day" :name="'due_at'" :format="'ddd MMM D, YYYY'" :label="$t('labels.from_to')" v-model="dateRange" :range="true" :insistFormat="'isoDate'" :error="error" />
      <tuxedo-radio :label="$t('labels.repeat_booking')" :name="'repeat'" v-model="resource.repeat" :options="{'null': $t('labels.off'), monthly: $t('labels.monthly'), six_monthly: $t('labels.six_monthly'), annually: $t('labels.annually')}" />
      <tuxedo-select :name="'task_groups'" :label="$tc('labels.task_group', 0)" v-model="resource.task_groups" :options="taskGroups" :multi="true" :error="error" />
      <tuxedo-select :name="'tasks'" :label="$tc('labels.task', 0)" v-model="resource.tasks" :options="tasks" :multi="true" :error="error" />
      <text-field :name="'description'" :label="$t('labels.description')" v-model="resource.description" :error="error"></text-field>
      <toggle-field :name="'notify_scheduled'" :label="$t('labels.notify.scheduled')" v-model="resource.notify_scheduled" :error="error"></toggle-field>
      <toggle-field :name="'notify_arrived'" :label="$t('labels.notify.arrived')" v-model="resource.notify_arrived" :error="error"></toggle-field>
      <toggle-field :name="'notify_left'" :label="$t('labels.notify.left')" v-model="resource.notify_left" :error="error"></toggle-field>
    </template>
  </bs-form>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BookingModal',
  props: ['resource'],
  data () {
    return {
      dateRange: [this.resource.due_at, this.resource.end_at]
    }
  },
  computed: {
    ...mapState({
      users: state => state.usersStore,
      customers: state => state.customersStore,
      properties: state => state.propertiesStore,
      taskGroups: state => state.taskGroupsStore,
      tasks: state => state.tasksStore
    })
  },
  watch: {
    'resource.customer_id': function (newVal) {
      this.$store.dispatch('index', { collection: 'Properties', path: 'customers', id: newVal, tag: 'properties' })
    },
    dateRange: function (newVal) {
      this.resource.due_at = newVal[0]
      this.resource.end_at = newVal[1]
    }
  }
}
</script>
